
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import { Observer } from 'mobx-vue'
import TooltipPop from '../../../views/ToolPopover/index.vue'

@Observer
@Component({
  components: {
    InfiniteLoading,
    TooltipPop
  }
})
export default class MyAccountCoin extends Vue {
  tooltipText: {
    title: string
    content: string[]
  } = {
    title: '如何获得桐板儿',
    content: [
      '1. 桐板儿是暄桐教室同学在成功购买课程时给予的返利优惠，仅可在暄桐教室购买课程时抵扣使用。桐板儿不能兑现，不可转让。',
      '2. 在暄桐教室购买课程订单且交易成功后，即可获得实付金额100:1数量的桐板儿（100元=1个桐板儿），如遇小数点，四舍五入取整。如实付学费小于100元，将不纳入桐板儿计算。如用户申请退课，在点击【申请退课】按钮时，将会扣除该课程订单所获得的桐板儿；点击【取消申请退课】按钮，桐板儿将再次返还用户的账户。',
      '3. 桐板儿可用于在暄桐教室网站支付课程订单 （1个桐板儿=8元）时的学费抵扣。用户实际支付金额不足8元时，可以使用一个桐板扣减至0元。使用桐板儿抵扣的课程订单在申请退课时，桐板儿将返回用户的账户。',
      '4. 如用户有任何疑问，可以向暄桐教室客服咨询。'
    ]
  }

  get pagePagination() {
    return this.$store.$myV2.Account.Coin.pagePagination
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
